import React from 'react';
import { useSelector } from 'react-redux';
import { Badge } from 'react-bootstrap';

function RequestForChangesBadge() {
  const pendingChangesCount = useSelector((state) =>
    state.requests.get('pendingChangesCount'),
  );

  const getLabel = (count) => (count < 100 ? count : '99+');

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {pendingChangesCount > 0 ? (
        <Badge bg="danger" pill>
          {getLabel(pendingChangesCount)}
        </Badge>
      ) : (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <></>
      )}
    </>
  );
}

export default RequestForChangesBadge;
